<template>
    <table class="wrapper">
        <tr>
            <td class="cell" :class="{selected: alignment.horizontal == 'left' && alignment.vertical == 'top'}" @click="select('left','top')" />
            <td class="cell" :class="{selected: alignment.horizontal == 'center' && alignment.vertical == 'top'}" @click="select('center','top')" />
            <td class="cell" :class="{selected: alignment.horizontal == 'right' && alignment.vertical == 'top'}" @click="select('right','top')" />
        </tr>
        <tr>
            <td class="cell" :class="{selected: alignment.horizontal == 'left' && alignment.vertical == 'center'}" @click="select('left','center')" />
            <td class="cell" :class="{selected: alignment.horizontal == 'center' && alignment.vertical == 'center'}" @click="select('center','center')" />
            <td class="cell" :class="{selected: alignment.horizontal == 'right' && alignment.vertical == 'center'}" @click="select('right','center')" />
        </tr>
        <tr>
            <td class="cell" :class="{selected: alignment.horizontal == 'left' && alignment.vertical == 'bottom'}" @click="select('left','bottom')" />
            <td class="cell" :class="{selected: alignment.horizontal == 'center' && alignment.vertical == 'bottom'}" @click="select('center','bottom')" />
            <td class="cell" :class="{selected: alignment.horizontal == 'right' && alignment.vertical == 'bottom'}" @click="select('right','bottom')" />
        </tr>
    </table>
</template>

<script>
    export default {

        props: {
            initAlign: {
                type: Object,
                default: () => null,
            }  
        },

        data(){
            return {
                alignment: this.initAlign ? this.initAlign : {
                    horizontal: 'center',
                    vertical: 'center',
                }
            }
        },

        computed: {
        },

        methods: {
            select(horAlign, verAlign){
                this.alignment.horizontal = horAlign
                this.alignment.vertical = verAlign
                this.$emit('update',this.alignment)
            }
        },
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        width: 60px;
        height: 60px;
        border-spacing: 0 !important;
        border-collapse: collapse !important;

        .cell {
            cursor: pointer;
            border: 1px solid #8a94a0;
            background: #f3f3f4;

            &:hover {
                background: #d3d9e1;
            }

            &.selected {
                background: #909399;
            }
        }
    }
</style>

